import React, { useRef, useEffect } from 'react';
import Draggable from 'react-draggable';
import '../../../styles/components/WebDemo/TranscriptPopup.css';

const TranscriptPopup = ({ allSentences, currentSentence, isTranslating, onClose, buttonPosition }) => {
  const transcriptContentRef = useRef(null);
  const defaultPosition = buttonPosition ? {
    x: buttonPosition.x - 150, // Center popup above button
    y: buttonPosition.y - 400  // Position above button with some spacing
  } : { x: 0, y: 0 };

  // Auto-scroll to bottom when content changes
  useEffect(() => {
    if (transcriptContentRef.current) {
      transcriptContentRef.current.scrollTop = transcriptContentRef.current.scrollHeight;
    }
  }, [allSentences, currentSentence, isTranslating]);

  return (
    <Draggable handle=".transcript-header" defaultPosition={defaultPosition}>
      <div className="transcript-popup">
        <div className="transcript-header">
          <h3>Transcript</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="transcript-content" ref={transcriptContentRef}>
          {/* Show completed (translated) sentences */}
          {allSentences.map((sentence, index) => (
            <div key={`sentence-${index}`} className="transcript-sentence completed">
              {sentence}
            </div>
          ))}
          
          {/* Show current sentence being built */}
          {currentSentence.length > 0 && (
            <div className="transcript-sentence current">
              {currentSentence.join(' ')}
              <span className="raw-indicator">(raw)</span>
            </div>
          )}
          
          {/* Show translation status if active */}
          {isTranslating && (
            <div className="transcript-status">
              <div className="loading-dots">Translating</div>
            </div>
          )}
          
          {/* Show empty state if no content */}
          {allSentences.length === 0 && currentSentence.length === 0 && !isTranslating && (
            <div className="transcript-empty">
              No sentences yet. Start signing to begin.
            </div>
          )}
        </div>
      </div>
    </Draggable>
  );
};

export default TranscriptPopup; 